import { makeStyles } from '@material-ui/core/styles'
import { cardHeaderStyles } from 'lib/styles/card-header'

const useStyles = makeStyles(theme => ({
  card: {
    border: '1px solid #E0E0E0',
    borderRadius: 12,
    backgroundColor: '#FFFFFF',
    overflow: 'hidden',
    minWidth: 0,
  },
  ...cardHeaderStyles(theme),
  // Compact on purpose: with one session Today's schedule is the shorter card
  // and Quick actions has to fit inside its height.
  cardHeader: {
    ...cardHeaderStyles(theme).cardHeader,
    padding: theme.spacing(1.5, 2.5),
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
    padding: theme.spacing(1.5, 2.5),
  },
  // Layout only: the fill, hover and shape come from the shared TonalButton.
  action: {
    justifyContent: 'flex-start',
    width: '100%',
    textAlign: 'left',
    '&&': {
      color: theme.palette.primary.main,
      height: 36,
      minHeight: 36,
    },
  },
}))

export default useStyles
